import { FlexAligner, LinkBase, Tooltip, Typography } from '@scaleaq/scaleui';

import { EllipsisTypography } from '@/styles.ts';
import { colors, responsive } from '@/utils';

import { StyledFooterBox } from './card.styles.ts';
import { FooterBoxProps, IAction } from './card.types.ts';

export const FooterBox = ({
  title,
  description,
  boldDescription = false,
  icon,
  alignment = 'center-left',
  navigationButton,
  tooltipDelay = 100,
  titleRight,
  fullWidth,
  ...rest
}: FooterBoxProps & { titleRight?: IAction }) => {
  const titleColor = colors.text.neutral[100];

  return (
    <StyledFooterBox {...rest} alignment={alignment} fullWidth={fullWidth}>
      <FlexAligner
        gap={responsive.spacing['xlarge']}
        alignment='center-left'
        fullWidth={!!titleRight}
      >
        {icon}
        <FlexAligner direction='column'>
          <FlexAligner spaceBetween={!!titleRight}>
            <FlexAligner gap='.3.125rem'>
              <Tooltip placement={'bottom'} delay={tooltipDelay} tooltip={title.toolTipText}>
                <EllipsisTypography style={{ fontWeight: '400' }} color={titleColor}>
                  {title.label}
                </EllipsisTypography>
              </Tooltip>
              {navigationButton && !titleRight && (
                <LinkBase>
                  <Tooltip
                    placement={'bottom'}
                    delay={tooltipDelay}
                    tooltip={navigationButton.toolTipText}
                  >
                    <Typography
                      type='body_large'
                      underline
                      color={titleColor}
                      style={{ fontWeight: `400` }}
                    >
                      {navigationButton.label}
                    </Typography>
                  </Tooltip>
                </LinkBase>
              )}
            </FlexAligner>
            {!navigationButton && titleRight && (
              <FlexAligner>
                <Tooltip placement={'bottom'} delay={tooltipDelay} tooltip={titleRight.toolTipText}>
                  <Typography type='body_large' color={titleColor} style={{ fontWeight: `400` }}>
                    {titleRight.label}
                  </Typography>
                </Tooltip>
              </FlexAligner>
            )}
          </FlexAligner>
          <Tooltip placement={'bottom'} delay={tooltipDelay} tooltip={description?.toolTipText}>
            <Typography type='body_large' style={{ fontWeight: boldDescription ? `700` : `400` }}>
              {description?.label}
            </Typography>
          </Tooltip>
        </FlexAligner>
      </FlexAligner>
    </StyledFooterBox>
  );
};
